import type { Capacity, EarthBalance, Plan } from './types';

export const CAPACITY_NAMES = {
  ex: '掘削・積込（バックホウ）',
  truck: '運搬（ダンプ）',
  roller: '敷均し・締固め（ローラ）',
} as const;

/** 3 つの能力（地山 m³/稼働日）とボトルネック。 */
export function capacity(p: Plan, eb: EarthBalance): Capacity {
  const hf = p.hours / 8;
  const so = eb.so;
  const ex = p.ex * p.qEx * hf;
  const capNat = p.cap / so.L;
  const dInt = Math.max(30, eb.avgHaul);
  const cycInt = 4 + ((2 * dInt) / 1000 / 15) * 60 + 2;
  const cycExt = 5 + ((2 * p.dExt) / 30) * 60 + 3;
  const tpm = (eb.extFrac * cycExt + (1 - eb.extFrac) * cycInt) / capNat;
  const truck = (p.trucks * p.hours * 60 * 0.85) / tpm;
  const roller = eb.Vf > 1 ? p.rollers * p.qR * hf * (eb.Q / eb.Vf) : Infinity;
  const list: [string, number][] = [
    [CAPACITY_NAMES.ex, ex],
    [CAPACITY_NAMES.truck, truck],
    [CAPACITY_NAMES.roller, roller],
  ];
  const min = Math.min(ex, truck, roller);
  const bn = list.find((x) => x[1] === min)?.[0] ?? CAPACITY_NAMES.ex;
  return { ex, truck, roller, min, bn, list, cycInt, cycExt, dInt, tpm };
}
